<script lang="ts">
    import Vue from "vue";
    import Component from 'vue-class-component';
    import { strCompareLowerCase } from '@common/Common';
    import { ProjectUsersTagsManagerViewModel } from "@Projects/Components/ProjectUsersTagsManager";


    @Component({
        props: {
            viewModel: {
                type: Object,
                required: true
            }
        }
    })
    export default class ProjectUsersTagsManager extends Vue
    {
        get vm(): ProjectUsersTagsManagerViewModel { return this.$props.viewModel as ProjectUsersTagsManagerViewModel; }
        get opened(): boolean { return this.vm?.opened ?? false; }

        get tagsView(): TagVM[] { return this.vm.tags?.sort((a, b) => strCompareLowerCase(a.tag, b.tag)); }

        handleCreateProjectUsersTag()
        {
            this.vm.createError = null;
            this.vm.updateError = null;

            this.$emit("create-tag", this.vm.newTag)
        }

        handleDeleteProjectUsersTag(tag: string)
        {
            this.$emit("delete-tag", tag)
        }

        handleUpdateProjectUsersTag(vm: TagVM)
        {
            this.vm.createError = null;
            this.vm.updateError = null;

            this.$emit("update-tag", vm.tag, vm.renamedTag);
        }

        close()
        {
            this.vm.close();
        }
    }
</script>

<template>
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog modal-lg modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Manage people tags</h5>
                        <button type="button" class="close" @click="close">&times;</button>
                    </div>

                    <div class="modal-body">
                        <div class="input-group">
                            <input type="text" v-model.trim="vm.newTag" class="form-control" placeholder="new tag...">
                            <div class="input-group-append">
                                <button class="btn btn-outline-secondary" type="button" :disabled="!vm.newTag" @click="handleCreateProjectUsersTag">Create tag</button>
                            </div>
                        </div>
                        <div class="error">{{vm.createError}}</div>

                        <table class="table table-hover mt-4">
                            <tbody>
                                <tr v-for="t in tagsView" :key="t.tag">
                                    <td>
                                        <span v-if="!t.editing" class="editable editable-secondary" @click="t.edit()">{{t.tag}}</span>
                                        <input v-if="t.editing" type="text" v-model.trim="t.renamedTag" class="form-control" />
                                        <div v-if="t.editing && updateError" class="error">{{updateError}}</div>
                                    </td>

                                    <td class="text-right" style="width: 100px;">
                                        <div v-if="!t.editing">
                                            <button type="button" @click="handleDeleteProjectUsersTag(t.tag)" class="btn btn-outline-secondary btn-sm" title="delete">
                                                <i class="fa fa-trash-can"></i>
                                            </button>
                                        </div>

                                        <div v-if="t.editing">
                                            <button type="button" @click="handleUpdateProjectUsersTag(t)" class="btn btn-primary btn-sm" title="confirm" :disabled="!t.canSave">
                                                <span class="fa fa-check"></span>
                                            </button>

                                            <button type="button" @click="t.cancelEdit()" class="btn btn-outline-secondary btn-sm" title="cancel">
                                                <span class="fa fa-times"></span>
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>

                        </table>

                    </div>

                    <!--<div class="modal-footer">

                    </div>-->
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
</style>